import * as React from 'react';
import {Query} from 'react-apollo';

import {formEncodedApi} from 'nutshell-core/api';

// @ts-expect-error
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import type {GetConstantContactIntegration as GetConstantContactIntegrationQuery} from 'nutshell-graphql-types';

import {openOauthWindow} from '../../../../oauth/open-oauth-window';

import {ConstantContactConnected} from './constant-contact-connected';
import {ConstantContactCTA} from './constant-contact-cta';
import GET_CONSTANT_CONTACT_INTEGRATION from './graphql/queries/constant-contact-integration-query.graphql';

import styles from './constant-contact-page.module.css';

type GraphQLProps = {
    constantContactIntegration:
        | GetConstantContactIntegrationQuery['constantContactIntegration']
        | null
        | undefined;
    isLoading: boolean;
    refetchIntegration: () => Promise<any>;
};

class ConstantContactPageComponent extends React.PureComponent<GraphQLProps> {
    render() {
        if (this.props.isLoading && !this.props.constantContactIntegration) {
            return (
                <div className={styles.container}>
                    <div className={styles['loading-container']}>
                        <LoadingIcon />
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.container}>
                {this.props.constantContactIntegration &&
                this.props.constantContactIntegration.isIntegrationActive ? (
                    <ConstantContactConnected
                        email={this.props.constantContactIntegration.email}
                        isContactSyncActive={
                            this.props.constantContactIntegration.isContactSyncActive
                        }
                        refetchIntegration={this.props.refetchIntegration}
                        onConstantContactConnect={this.handleConstantContactConnect}
                    />
                ) : (
                    <ConstantContactCTA
                        onConstantContactConnect={this.handleConstantContactConnect}
                    />
                )}
            </div>
        );
    }

    handleConstantContactConnect = () => {
        const windowFeatures = {
            width: 490,
            height: 600,
            toolbar: 'no',
            location: 'no',
            alwaysRaised: 'yes',
        } as const;

        // @todo this is a bit fragile : NUT-11786
        return openOauthWindow(
            `/setup/instant-integration/edit-constant-contact?redirect=https%3A%2F%2F${window.location.hostname}%2Fsetup%2Fintegration%2Fconstant-contact-popup-callback`,
            'Constant Contact',
            windowFeatures
        ).then(() => {
            return (
                formEncodedApi
                    .get('/integrations/status')
                    // @ts-expect-error
                    .then((res) => res.json())
                    .then((json) => {
                        if (json.integrationsEnabled && json.integrationsEnabled.constantContact) {
                            if (NutClientConfig.integrations) {
                                NutClientConfig.integrations.constantContactEnabled = true;
                            }

                            return this.props.refetchIntegration();
                        }
                    })
            );
        });
    };
}

class ConstantContactIntegrationQuery extends Query<
    GetConstantContactIntegrationQuery,
    Record<any, any>
> {}

export const ConstantContactPage = () => (
    <ConstantContactIntegrationQuery
        query={GET_CONSTANT_CONTACT_INTEGRATION}
        // @ts-expect-error
        fetchPolicy='cache-and-network'
    >
        {({data, loading, refetch}) => {
            const constantContactIntegration = data ? data.constantContactIntegration : null;

            return (
                <ConstantContactPageComponent
                    constantContactIntegration={constantContactIntegration}
                    isLoading={loading}
                    refetchIntegration={refetch}
                />
            );
        }}
    </ConstantContactIntegrationQuery>
);
